import { css } from '@emotion/css'
import { spacing, shorthandHelper } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    textAlign: 'center',
  }),

  text: css({
    margin: shorthandHelper([spacing.default, 0]),

    '& p': {
      margin: 0,
    },
  }),

  buttonContainer: css({
    display: 'flex',
    justifyContent: 'center',
  }),
}

export default styles
